export default "__VITE_ASSET__D8aYCljL__"